import { render, staticRenderFns } from "./Regras.vue?vue&type=template&id=657e899e&scoped=true"
import script from "./Regras.vue?vue&type=script&lang=js"
export * from "./Regras.vue?vue&type=script&lang=js"
import style0 from "./Regras.vue?vue&type=style&index=0&id=657e899e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e899e",
  null
  
)

export default component.exports